<form (click)="debugForm(constructor.name)" (keydown)="(null)" class="pt-4">
  <div class="form-wrapper">
    <div class="field-wrapper">
      <aura-input-code-verification [label]="'Code de vérification'" (codeChange)="onCodeChange($event)" />
    </div>
  </div>
</form>
